import { render, staticRenderFns } from "./CompartmentDesign.vue?vue&type=template&id=50dc5800&scoped=true&"
import script from "./CompartmentDesign.vue?vue&type=script&lang=js&"
export * from "./CompartmentDesign.vue?vue&type=script&lang=js&"
import style0 from "../../assets/compartmentDesign.css?vue&type=style&index=0&id=50dc5800&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50dc5800",
  null
  
)

export default component.exports